import { Tkv2ReferenceViewModule } from '../../modules/referenceView/Tkv2ReferenceViewModule.tsx';

export const Tkv2MlsPropertyMapRouteElement = () => {
  return <Tkv2ReferenceViewModule isPopout dataSheet="mls-map" />;
};
